import overlayStyles from "../../styles/UI/overlay.module.css"

const Overlay = ({
  children,
  clickAway,
  darkBackground,
  zIndex
}: {
  children: React.ReactNode | React.ReactNode[];
  clickAway: () => void
  darkBackground?: boolean;
  zIndex?: number;
}) => {
  return (
    <section
      className={overlayStyles.overlay}
      style={{
        backgroundColor: darkBackground ? 'rgba(0,0,0, 0.3)' : 'transparent',
        zIndex: zIndex || 1000
      }}
      onClick={() => {
        clickAway()
      }}
    >
      {children}
    </section>
  );
};

export default Overlay;